export function keyValueFilter(collection, key, value) {
  if (!key || !value) {
    return collection;
  }

  // currently only check for one level key-value
  // if needed, it can call a recursive function to loop through nested objects or arrays
  return collection.filter((c) => {
    let isMatching = false;
    Object.keys(c).forEach((key) => {
      switch (typeof c[key]) {
        case "number":
          isMatching =
            isMatching || c[key].toString().indexOf(value.toString()) !== -1;
          break;
        case "string":
          isMatching =
            isMatching ||
            c[key].toUpperCase().indexOf(value.toUpperCase()) !== -1;
          break;
        default:
          break;
      }
    });
    return isMatching;
  });
}
